import React from "react";

const About = () => {
  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container py-5">

        {/* Heading */}
        <div className="text-center mb-5">
          <h6 className="text-primary text-uppercase fw-bold">
            About Company
          </h6>

          <h1 className="display-5 fw-bold">
            Engineering Construction and Interiors Pvt. Ltd.
          </h1>

          <p
            className="text-muted mx-auto mt-3"
            style={{ maxWidth: "850px" }}
          >
            Engineering Construction and Interiors Pvt. Ltd. is a trusted
            construction and interior solutions company committed to delivering
            excellence in residential and commercial projects.
          </p>
        </div>

        {/* About Section */}
        <div className="row g-4 align-items-center">

          {/* Left Side */}
          <div className="col-lg-6">
            <div className="bg-white shadow rounded p-4 h-100">

              <h3 className="mb-4 text-primary">Who We Are</h3>

              <p className="text-secondary">
                We specialize in construction, interior execution, renovation,
                modular solutions, and turnkey projects with a strong focus on
                quality, innovation, and customer satisfaction.
              </p>

              <p className="text-secondary">
                Our experienced team combines technical expertise with modern
                design concepts to create spaces that are functional, durable,
                and visually appealing.
              </p>

              <p className="text-secondary mb-0">
                Every project is handled with professionalism, precision, and a
                commitment to timely delivery. We believe in building long-term
                relationships through transparency, reliability, and exceptional
                workmanship.
              </p>

            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-6">
            <div className="row g-4">

              {/* Mission */}
              <div className="col-md-12">
                <div className="bg-primary text-white shadow rounded p-4">

                  <h4 className="mb-3">Our Mission</h4>

                  <p className="mb-0">
                    To provide innovative, reliable, and high-quality
                    construction and interior solutions that exceed client
                    expectations while ensuring timely project completion and
                    professional service.
                  </p>

                </div>
              </div>

              {/* Vision */}
              <div className="col-md-12">
                <div className="bg-dark text-white shadow rounded p-4">

                  <h4 className="mb-3">Our Vision</h4>

                  <p className="mb-0">
                    To become a leading name in the construction and interiors
                    industry by consistently delivering excellence, trust, and
                    customer satisfaction.
                  </p>

                </div>
              </div>

            </div>
          </div>

        </div>

        {/* Leadership Section */}
        <div className="text-center mt-5 mb-5">

          <h6 className="text-primary text-uppercase fw-bold">
            Our Leadership
          </h6>

          <h2 className="fw-bold">Meet the Directors</h2>

          <p className="text-muted">
            ECI is led by experienced professionals committed to excellence in
            every project we undertake.
          </p>

        </div>

        {/* Directors */}
        <div className="row g-4">

          {/* Director 1 */}
          <div className="col-lg-6">
            <div className="bg-white shadow rounded overflow-hidden h-100 border-top border-4 border-primary">

              <div className="row g-0 align-items-center">

                {/* Content */}
                <div className="col-md-7">
                  <div className="p-4">

                    <h3 className="fw-bold mb-1">
                      Muteeb Ahmad Khan
                    </h3>

                    <h6 className="text-primary mb-3">
                      Director, ECI Pvt. Ltd.
                    </h6>

                    <p className="mb-2 fw-semibold">
                      📞 +91 78002 60986
                    </p>

                    <p className="text-secondary mb-0"
                      style={{
                        textAlign: "justify",
                        lineHeight: "28px"
                      }}
                    >
                      Muteeb Ahmad Khan brings strong vision and technical
                      leadership to Engineering Construction and Interiors Pvt.
                      Ltd. He oversees project execution, client coordination,
                      and business development while ensuring every project
                      meets the company’s high standards of quality and
                      professionalism.
                    </p>

                  </div>
                </div>

                {/* Image */}
                <div className="col-md-5">
                  <img
                    src="/img/teams-1.jpg"
                    alt="Muteeb Ahmad Khan"
                    className="img-fluid w-100 h-100"
                    style={{
                      objectFit: "cover",
                      minHeight: "320px"
                    }}
                  />
                </div>

              </div>
            </div>
          </div>

          {/* Director 2 */}
          <div className="col-lg-6">
            <div className="bg-white shadow rounded overflow-hidden h-100 border-top border-4 border-dark">

              <div className="row g-0 align-items-center">

                {/* Content */}
                <div className="col-md-7">
                  <div className="p-4">

                    <h3 className="fw-bold mb-1">
                      Arvind Kumar
                    </h3>

                    <h6 className="text-primary mb-3">
                      General Manager, ECI Pvt. Ltd.
                    </h6>

                    <p className="mb-2 fw-semibold">
                      📞 +91 98244 40003
                    </p>

                    <p
                      className="text-secondary mb-0"
                      style={{
                        textAlign: "justify",
                        lineHeight: "28px"
                      }}
                    >
                      Arvind Kumar leads the operational and strategic
                      foundation of Engineering Construction and Interiors Pvt.
                      Ltd. With extensive hands-on expertise in construction
                      management and project execution, he ensures every project
                      is completed with precision, efficiency, and superior
                      craftsmanship.
                    </p>
                  </div>
                </div>

                {/* Image */}
                <div className="col-md-5">
                  <img
                    src="/img/team-2.jpg"
                    alt="Arvind Kumar"
                    className="img-fluid w-100 h-100"
                    style={{
                      objectFit: "cover",
                      minHeight: "320px"
                    }}
                  />
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default About;